<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
    <div class="row filter-row">
      <div class="col-sm-6 col-md-2">
        <div class="input-block mb-3 form-focus focused">
          <input
            type="date"
            class="form-control floating"
            :style="`${
              filters.from_date &&
              'border-bottom: var(--primary-color) 2px solid;'
            }`"
            v-model="filters.from_date"
            @focus="isFocusedFromDate = true"
            @blur="isFocusedFromDate = from_date !== ''"
          />
          <label class="focus-label">From</label>
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mb-3 form-focus focused">
          <input
            type="date"
            class="form-control floating"
            :style="`${
              filters.to_date &&
              'border-bottom: var(--primary-color) 2px solid;'
            }`"
            v-model="filters.to_date"
            @focus="isFocusedToDate = true"
            @blur="isFocusedToDate = to_date !== ''"
          />
          <label class="focus-label">To</label>
        </div>
      </div>
      <div class="col-md-5"></div>
      <div class="d-flex col-sm-6 col-md-3 gap-2">
        <button
          type="submit"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="handleFilters"
        >
          Search
        </button>
        <button
          type="button"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="resetAllFilters"
        >
          Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        from_date: "",
        to_date: "",
      },
      isFocusedFromDate: false,
      isFocusedToDate: false,
      searched: false,
    };
  },
  props: {},
  methods: {
    handleFilters() {
      this.searched = true;
      this.$emit("apply-filters", this.filters);
    },

    handleClearOneFilter(fieldName) {
      this.filters[fieldName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      this.$emit("apply-filters", this.filters);

      this.searched = false;
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        from_date: "",
        to_date: "",
      };
      this.searched = false;
    },
  },
  created() {
    this.searched = false;
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>
